import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  approveRejectTickets,
  fetchCurrentChallenger,
  fetchCurrentChampion,
  fetchScenarioTypologies
} from '../../../redux/actions/trm/trmDashboard';
import { bindActionCreators } from 'redux';
import TicketDetails from './TicketDetail';

/**
 *
 * @param state
 * @param ownProps
 * @returns {{}}
 */
const mapStateToProps = (state) => ({
  trmDashboard: state.trmDashboard
});

/**
 *
 * @param dispatch
 * @param ownProps
 * @returns {{}}
 */
const mapDispatchToProps = (dispatch) => ({
  apiActions: bindActionCreators(
    {
      fetchCurrentChallenger,
      fetchCurrentChampion,
      approveRejectTickets,
      fetchScenarioTypologies
    },
    dispatch
  )
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketDetails)
);
